/**
 * File: FormHeader.js
 * Origin: isotect
 * Description: FormHeader component for forms.
 *
 * Version: v1.2.0
 * Created: 2025-07-24
 * Last Updated: 2026-04-11
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { IconButton } from "../ui/Buttons";

// Icons
import { MdClose } from "react-icons/md";

/**
 * FormHeader component renders the main heading and subheading for a form.
 *
 * @component
 *
 * @param {Object} props - Component properties
 * @param {string} props.header - Main header text of the form
 * @param {string} props.subheader - Subheader text of the form
 *
 * @returns {JSX.Element} A form heading section with main header and subheader
 *
 * @example
 * <FormHeader
 *   header="Sign In"
 *   subheader="Welcome back! Please enter your credentials."
 * />
 */
function FormHeader({
    header,
    subheader,
    closeButton = false,
    onClick = null,
    alignLeft = false,
}) {
    return (
        <>
            <div className="form-header">
                <div className="form-header__container">
                    <h3
                        className={`form-header__header ${alignLeft ? "form-header__header--align-left" : ""}`}
                    >
                        {header}
                    </h3>
                    {closeButton ? (
                        <IconButton
                            icon={MdClose}
                            onClick={onClick}
                            size={24}
                        />
                    ) : null}
                </div>
                <p
                    className={`form-header__subheader ${alignLeft ? "form-header__subheader--align-left" : ""}`}
                >
                    {subheader}
                </p>
            </div>
        </>
    );
}

export default FormHeader;
